import type { Color } from 'src/types/theme';

export const green: Color = {
  50: '#ecfcee',
  100: '#d2efd5',
  200: '#b4e4b9',
  300: '#96d99d',
  400: '#78ce81',
  500: '#5ac465',
  600: '#3da948',
  700: '#2e7f36',
  800: '#1f5625',
  900: '#102d13',
};
